<template>
    <modal v-model="openModal" size="lg" :title="trans('general.page.planners.appointment')">
        <FormErrorAlerts :errors="errors"></FormErrorAlerts>

        <div class="row g-2">
            <div class="col-md-6 mb-3">
                <div class="form-floating">
                    <input type="text" v-model="model.title"  class="form-control" name="title" id="title">
                    <label for="description"> {{ trans('general.page.planners.plan_form.title') }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-floating">
                    <datepicker required class="form-control" v-model="date" :language="language()"
                                format="dd-MM-yyyy">
                    </datepicker>
                    <label for="date">{{ trans('general.page.planners.plan_form.date') }}</label>
                </div>
            </div>

            <div v-if="!allDay" class="col-md-6 mb-3">
                <div class="form-floating">
                    <vue-timepicker class="form-control w-100" id="start" :minute-interval="15"
                                    v-model="from" name="from" drop-direction="auto"
                                    :drop-offset-height="200" auto-scroll hide-clear-button>
                    </vue-timepicker>
                    <label for="start">{{ trans('general.page.planners.plan_form.start') }}</label>
                </div>
            </div>
            <div v-if="!allDay" class="col-md-6 mb-3">
                <div class="form-floating">
                    <vue-timepicker class="form-control w-100" id="end" :minute-interval="15"
                                    v-model="to" name="to" required="true"
                                    :hour-range="fromH" :minute-range="fromM"
                                    drop-direction="auto" :drop-offset-height="200" auto-scroll
                                    hide-clear-button></vue-timepicker>
                    <label for="end">{{ trans('general.page.planners.plan_form.end') }}</label>
                </div>
            </div>
            <div class="col-12 mb-3">
                <div class="form-floating">
                                <textarea v-model="model.description" class="form-control" name="description"
                                          id="description" cols="30" rows="10"></textarea>
                    <label for="description"> {{ trans('general.page.planners.plan_form.description') }}</label>
                </div>
            </div>
        </div>
        <div v-if="model.members && model.members.length">
            <h5 >{{trans('general.page.planners.plan_form.chosen_members')}}: </h5>
            <div class="d-flex flex-wrap gap-2">
                <div class="card  px-3 py-2" v-for="member in model.members"
                     :class="{'bg-light-green text-dark-green': member.pivot.approved_at, 'bg-light-red text-danger': member.pivot.rejected_at}">
                    {{ member.pivot.approved_at ? '✅' : (member.pivot.rejected_at ? '❌' : '') }} {{ member.name }}
                    {{ member.surname }}
                </div>
            </div>
        </div>

        <plan-form-footer :model="model" v-on:submit="submit" v-on="$listeners"/>
    </modal>
</template>

<script>
import Modal from "../../../theme/organisms/Modal";
import EventFormHead from "../atoms/EventFormHead";
import FormErrorAlerts from "../../../theme/molecules/FormErrorAlerts"
import datepicker from 'vuejs-datepicker';
import PlanForm from "./PlanForm";
import PlanFormFooter, {SUBMIT_PLAN_WAITER} from "./PlanFormFooter";
import moment from "moment";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker";
import Treeselect from "@riophae/vue-treeselect";

export default {
    name: "AppointmentForm",
    extends: PlanForm,
    components: {
        Treeselect,
        Modal,
        EventFormHead,
        FormErrorAlerts,
        datepicker,
        PlanFormFooter,
        VueTimepicker
    },

    data() {
        return {
            allDay: true,
            date: null,
            from: moment().format('HH:mm'),
            to: '',
            users: [],
        }
    },
    computed: {
        fromH() {
            let h = this.from ? parseInt(this.from.split(':')[0]) : 0
            return [[h, 23]]
        },

        fromM() {
            let hf = this.from ? parseInt(this.from.split(':')[0]) : null
            let h = this.to ? parseInt(this.to.split(':')[0]) : null;
            let m = this.from && hf === h ? parseInt(this.from.split(':')[1]) + 1 : 0

            return [[m, 59]]
        }

    },
    methods: {
        open(model) {
            this.clear();
            this.model = {...this.model, ...(model || {})} || this.model;
            this.date = moment(model.start).format('YYYY-MM-DD');

            if (model.end) {
                this.from = moment(model.start, 'YYYY-MM-DD HH:mm').format('HH:mm')
                this.to = moment(model.end, 'YYYY-MM-DD HH:mm').format('HH:mm')

                this.allDay = this.to === '00:00' && model.id;
            }

            this.openModal = true;
        },
        submit() {
            let url = !this.model.id ? `/plans/new` : `/plans/${this.model.id}`;
            this.model.type = this.eventType;

            let data = {...this.model};

            const date = moment(this.date).format('YYYY-MM-DD')
            const start = moment(date + ' ' + this.from, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
            let end = null;

            if(! this.allDay) {
                end = moment(date + ' ' + this.to, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
            }

            data = {...data, start, end}

            axios.post(url, data)
                .then(response => {
                    this.$emit('event-saved', response.data.data)
                    this.$wait.end(SUBMIT_PLAN_WAITER);
                })
                .catch(error => {
                    this.$wait.end(SUBMIT_PLAN_WAITER);
                    if (error.response.data.message === '' && error.response.data.errors) {
                        let errors = Object.values(error.response.data.errors);
                        this.errors = errors.map(val => val[0] || 0)
                    } else {
                        this.$notify({type: 'error', text: error.response.data.message});
                    }
                })
        },

        clear() {
            this.errors = [];
            this.model = {...this.initialModel};
            this.from = moment().format('HH:mm');
            this.to = '';
            this.allDay = true;
        },
    }
}
</script>
